import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, OnInit, Output, WritableSignal, signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { BetslipType } from '../../../../core/betslip-type';
import LinearBetslipTrackingActions from '../../../tracking/state/linear-tracking.actions';
import { LinearModuleContentDirective } from './directives/linear-module-content.directive';
import { LinearModuleHeaderDirective } from './directives/linear-module-header.directive';

@Component({
    selector: 'bs-linear-module-container',
    templateUrl: './linear-module-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./linear-module-container.component.scss'],
    standalone: false,
})
export default class LinearModuleContainerComponent implements OnInit {
    @ContentChild(LinearModuleHeaderDirective) header: LinearModuleHeaderDirective | undefined;
    @ContentChild(LinearModuleContentDirective) content: LinearModuleContentDirective | undefined;
    @Input() expandable = false;
    @Input() defaultExpanded = true;
    @Input() trackingBetslipTypeContext?: BetslipType;
    @Output() expandedChanged = new EventEmitter<boolean>();

    isExpanded: WritableSignal<boolean>;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.isExpanded = signal(this.defaultExpanded);
    }

    toggleExpand(event: MouseEvent): void {
        if (!this.expandable) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.isExpanded.update((v) => !v);

        this.expandedChanged.emit(this.isExpanded());

        if (!this.trackingBetslipTypeContext) {
            return;
        }

        this.store.dispatch(
            LinearBetslipTrackingActions.toggleModuleExpansion({
                betslipType: this.trackingBetslipTypeContext,
                isExpanded: this.isExpanded(),
            }),
        );
    }
}
